import { FETCH_GIFT_CARD } from 'actions/apiActionConstants'
import { reducerSwitch, createReducer } from 'lib/redux/reducerUtils'
import { API_CALL_REQUEST, API_CALL_FAILURE, API_CALL_SUCCESS } from 'actions/actionConstants'

export const initialGiftCardState: App.GiftCardState = {
  error: {},
  fetching: false,
  giftCard: undefined,
  giftCardOptions: [],
}

const apiRequests = reducerSwitch<App.GiftCardState>({
  [FETCH_GIFT_CARD]: () => ({
    fetching: true,
    error: undefined,
  }),
})

const apiSuccesses = reducerSwitch<App.GiftCardState>({
  [FETCH_GIFT_CARD]: (state, action) => ({
    giftCard: action.data,
    fetching: false,
  }),
})

const apiFailures = reducerSwitch<App.GiftCardState>({
  [FETCH_GIFT_CARD]: (state, action) => ({
    fetching: false,
    error: action.error,
  }),
})

export default createReducer<App.GiftCardState>(initialGiftCardState, {
  [API_CALL_REQUEST]: (state, action) => apiRequests(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiFailures(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiSuccesses(action.api)(state, action),
})
